import React, { useState, useEffect, useCallback } from "react";
import DatePicker from "react-datepicker";
import { fr } from "date-fns/locale";
import { format } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";

import axiosConfig from "../../utils/axiosConfig";
import { getTimeSlotsOptions } from "../../utils/general";

// Calendrier de prise de RDV côté expert.
// Seuls les créneaux LIBRES sont cliquables : les créneaux déjà pris par un
// autre dossier (ou bloqués) sont désactivés, jamais sélectionnables.
const AppointmentPicker = ({
  date = "",
  hour = "",
  excludeFolderId = null,
  expertId = null,
  onChange,
}) => {
  const [unavailableSlots, setUnavailableSlots] = useState([]);
  const [isLoad, setIsLoad] = useState(false);

  const fetchUnavailableSlots = useCallback(
    (value) => {
      if (!value) {
        setUnavailableSlots([]);
        return;
      }
      setIsLoad(true);
      axiosConfig("folder/get-unavailable-slots", {
        data: { date: value, excludeFolderId, expertId },
      })
        .then((res) => {
          setUnavailableSlots(
            res.data && res.data.success ? res.data.unavailableSlots || [] : []
          );
        })
        .catch(() => setUnavailableSlots([]))
        .finally(() => setIsLoad(false));
    },
    [excludeFolderId, expertId]
  );

  useEffect(() => {
    fetchUnavailableSlots(date);
  }, [date, fetchUnavailableSlots]);

  // Week-end non réservable (aligné sur la règle serveur)
  const isWeekday = (value) => {
    const day = value.getDay();
    return day !== 0 && day !== 6;
  };

  const handleDateChange = (value) => {
    // Changer de date remet le créneau à zéro (il peut être pris ce jour-là)
    onChange({
      date: value ? format(value, "yyyy-MM-dd") : "",
      hour: "",
    });
  };

  const slots = getTimeSlotsOptions().filter((slot) => slot.value);

  return (
    <div>
      <DatePicker
        selected={date ? new Date(`${date}T00:00:00`) : null}
        onChange={handleDateChange}
        filterDate={isWeekday}
        minDate={new Date()}
        locale={fr}
        dateFormat="dd/MM/yyyy"
        placeholderText="Choisir une date"
        inline
      />
      {date ? (
        <div className="mt-10">
          <p className="m-0 mb-10" style={{ fontSize: 14 }}>
            {isLoad ? "Chargement des créneaux..." : "Créneaux libres"}
          </p>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
            {slots.map((slot) => {
              const isTaken = unavailableSlots.includes(slot.value);
              const isSelected = hour === slot.value;
              return (
                <button
                  key={slot.value}
                  type="button"
                  disabled={isTaken || isLoad}
                  onClick={() => onChange({ date, hour: slot.value })}
                  title={
                    isTaken ? "Créneau déjà pris" : "Créneau libre"
                  }
                  style={{
                    minWidth: 72,
                    padding: "6px 10px",
                    borderRadius: 6,
                    fontSize: 13,
                    fontWeight: 500,
                    cursor: isTaken ? "not-allowed" : "pointer",
                    border: "1px solid",
                    borderColor: isSelected ? "#1d6f42" : "#d0d0d0",
                    backgroundColor: isTaken
                      ? "#ececec"
                      : isSelected
                      ? "#4caa2a"
                      : "#ffffff",
                    color: isTaken ? "#9b9b9b" : isSelected ? "#ffffff" : "#333",
                    textDecoration: isTaken ? "line-through" : "none",
                  }}
                >
                  {slot.text}
                </button>
              );
            })}
          </div>
        </div>
      ) : (
        <p className="m-0 mt-10" style={{ fontSize: 13, color: "#777" }}>
          Choisissez une date pour voir les créneaux libres.
        </p>
      )}
    </div>
  );
};

export default AppointmentPicker;
